import PropTypes from 'prop-types';
import { Form, OverlayTrigger, Tooltip, Row, Col } from "react-bootstrap";


//NEPAS UTILISER NE LOG PAS LES CHANGEMENT DE VALEUR, pas de RadioNodeList...
/**
 * Composant affichant un champ bootstrap "checkbox", différents types possibles par bottstrap: checkbox, radio, switch"
 *
 * @component
 * @return { HTMLElement }
 *  <FormCheck id="NIVEAU_ENTREE_OBLIGATOIRE" infosProp={props.infosProprietes["ACTIONS_SESSIONS|NIVEAU_ENTREE_OBLIGATOIRE"]}/>
*/
function FormCheck({ register, errors, id, infosProp, typeCheckbox, ...rest }) {
    var idElement = id;

    if(infosProp != null && infosProp.lib_form != null) {
        var editable = infosProp.editable;
        var libelle = infosProp.lib_form;
        var isRequired = infosProp.required > 0 ? true : false;
        var aide = infosProp.aide;
    }

    const renderTooltip = (props) => (
        <Tooltip id="button-tooltip" {...props}>
          <div dangerouslySetInnerHTML={{ __html:  aide }}></div>
        </Tooltip>
    );

/* info Auto-sizing  et disposition en colonne : https://react-bootstrap.github.io/forms/layout/
Form.Check  a un atribut label que nous n'utlisont pas , ainsi on Utilie Form.label comme ailleurs

attention required a été retiré comme c'est un checkbok : ...register(idElement, { required: isRequired}) */
    return (
        <>
        {idElement == null ?
            <>idElement indefini</>
        : 
            <Form.Group 
                className= { isRequired ?  "mb-3 required" : "mb-3" }
                controlId={idElement}> {/*controlId permet de mettre un for dans le label et un id identique dans le controle*/ }
                    <Row>
                        <Col xs="auto">
                            <Form.Label>{libelle}</Form.Label>
                        </Col>
                    
                        <Col xs="auto">
                        <Form.Check 
                        type={typeCheckbox}
                        {...register(idElement)}
                        disabled= {editable == 0 && "disabled"}
                        />  
                        </Col>
                    
                        <Col xs="auto">
                        {aide != null && aide != "" && 
                        <OverlayTrigger  placement="right" overlay={renderTooltip} >   
                            <button className="simply" type='button'><span className="fas fa-circle-question"></span></button>
                        </OverlayTrigger>
                        }
                        </Col>
                    </Row>
                    {errors?.[idElement] && (
                    <Form.Text className="text-danger">
                        {errors && <p>Erreur inconnue</p>}
                    </Form.Text>
                    )}
            </Form.Group>
        }
        </>

    )
}

FormCheck.propTypes = {
    id: PropTypes.string.isRequired,
    infosProp: PropTypes.object,
    errors: PropTypes.object,
}

export default FormCheck